import { connect } from 'react-redux';
import { useProperty, useTranslation } from '@eti/providers';
import { getSelected } from '../../single-choice/utils/selection';
import { PLATINUM_SERVICE } from '../../products';
import { ProductCardLayoutType } from '../../common/models/product';
import MainPlatinum from './MainPlatinum';
import { jsx as _jsx } from "react/jsx-runtime";
const Platinum = props => {
  const {
    p
  } = useProperty();
  const {
    t
  } = useTranslation();
  const isPlatinumEnabled = p('IbeClient.Platinum.Enabled');
  if (!isPlatinumEnabled) {
    return null;
  }
  switch (props.layoutType) {
    case ProductCardLayoutType.PostBooking:
      return /*#__PURE__*/_jsx(MainPlatinum, {
        platinumPriceLabel: t('Products.Price.Label.Total'),
        ...props
      });
    case ProductCardLayoutType.Main:
    default:
      return /*#__PURE__*/_jsx(MainPlatinum, {
        platinumPriceLabel: t('Products.Price.Label.Only'),
        ...props
      });
  }
};
const mapStateToProps = (state, _ref) => {
  let {
    form
  } = _ref;
  const productName = PLATINUM_SERVICE.name;
  return {
    isSelected: getSelected(productName, form)(state)
  };
};
export default connect(mapStateToProps)(Platinum);